<div class="container">
	<div class="filtrante" *ngIf="data.filter_first_image">
		<app-image [path]="data.filter_first_image.url"></app-image>
	</div>
</div>
